export default __webpack_public_path__ + "static/media/element_22.a0176230.avif";